export default __webpack_public_path__ + "static/media/female_face.d6ec0e41.png";